import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import ChargeDetailSection from "./chargeDetailSection";
import { Col, Form, Row } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import React from "react";
import { formatPhoneNumber } from "utils/localizations";
import { emptyValue } from "utils/emptyValue";

const ChargeDetailContactSection: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  const contact = vm.item.notificationPreferences;

  return (
    <ChargeDetailSection title={vm.translate("contactDetail")}>
      <Row>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeContactDetailResponse", "notificationEmailAddress")}</Form.Label>
          <FakeInput
            target={contact}
            property="notificationEmailAddress"
            valueFormatter={value => (!value ? emptyValue : value)}
          />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeContactDetailResponse", "notificationPhoneNumber")}</Form.Label>
          <FakeInput
            target={contact}
            property="notificationPhoneNumber"
            valueFormatter={value => (!value ? emptyValue : formatPhoneNumber(value))}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeContactDetailResponse", "emailNotificationEnabled")}</Form.Label>
          <FakeInput
            target={contact}
            property="emailNotificationEnabled"
            valueFormatter={value => vm.translateGeneral(`boolean.${value}`)}
          />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeContactDetailResponse", "smsNotificationEnabled")}</Form.Label>
          <FakeInput
            target={contact}
            property="smsNotificationEnabled"
            valueFormatter={value => vm.translateGeneral(`boolean.${value}`)}
          />
        </Form.Group>
      </Row>
    </ChargeDetailSection>
  );
});

export default ChargeDetailContactSection;
